import React from 'react';
import { Box, Typography, Chip } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const opcionesFiltros = [
  { value: 'cliente', label: 'Cliente' },
  { value: 'direccion', label: 'Dirección' },
  { value: 'localidad', label: 'Localidad' },
  { value: 'telefono', label: 'Teléfono' },
  { value: 'cuit', label: 'CUIT' },
  { value: 'sisven', label: 'SISVEN' }
];

const ChipsFiltrosActivos = ({ filtrosSeleccionados, onFiltrosChange }) => {
  const handleRemoveFiltro = (filtroToRemove) => {
    const nuevosFiltros = filtrosSeleccionados.filter(f => f !== filtroToRemove);
    onFiltrosChange(nuevosFiltros);
  };

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0, alignItems: 'center' }}>
      {filtrosSeleccionados.map((filtro) => {
        const opcion = opcionesFiltros.find(f => f.value === filtro);
        return (
          <Chip
            key={filtro}
            label={opcion?.label}
            size="small"
            variant="outlined"
            onDelete={() => handleRemoveFiltro(filtro)}
            deleteIcon={<CancelIcon sx={{ fontSize: '14px' }} />}
            sx={{
              backgroundColor: 'white',
              borderColor: 'grey.200',
              color: 'grey.700',
              fontSize: '0.75rem',
              height: '24px',
              '& .MuiChip-label': {
                px: 1
              },
              '& .MuiChip-deleteIcon': {
                fontSize: '16px',
                color: 'grey.400',
                '&:hover': {
                  color: 'grey.600'
                }
              }
            }}
          />
        );
      })}
      
      {filtrosSeleccionados.length === 0 && (
        <Typography 
          variant="caption" 
          sx={{ 
            color: 'grey.400',
            fontSize: '0.75rem'
          }}
        >
          Todos los campos visibles
        </Typography>
      )}
    </Box>
  );
};

export default ChipsFiltrosActivos;